export default __webpack_public_path__ + "static/media/ricejpg.6a52a93f.jpg";